import React, { createContext, useState, useContext, useEffect } from 'react';
import translations from '../translations';

// Create a context for language
const LanguageContext = createContext();

// Custom hook to use the language context
export const useLanguage = () => useContext(LanguageContext);

// Provider component for the language context
export const LanguageProvider = ({ children }) => {
  // Get the stored language from localStorage or default to 'ro' (Romanian)
  const [language, setLanguage] = useState(() => {
    const storedLanguage = localStorage.getItem('language');
    return storedLanguage || 'ro'; // Default to Romanian
  });

  // When language changes, save it to localStorage
  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  // Function to toggle between languages
  const toggleLanguage = () => {
    setLanguage(prevLang => prevLang === 'en' ? 'ro' : 'en');
  };

  // Function to set a specific language
  const changeLanguage = (lang) => {
    if (['en', 'ro'].includes(lang)) {
      setLanguage(lang);
    }
  };

  // Translation function
  const t = (key) => {
    // Split the key by dots (e.g., 'header.about')
    const keys = key.split('.');
    
    // Start with the entire translation object for the current language
    let value = translations[language];
    
    // Navigate through the keys to get the translated value
    for (const k of keys) {
      if (value && value[k] !== undefined) {
        value = value[k];
      } else {
        // If the key doesn't exist, return the key itself as fallback
        return key;
      }
    }
    
    return value;
  };

  // The context value to be provided
  const contextValue = {
    language,
    toggleLanguage,
    changeLanguage,
    t
  };

  return (
    <LanguageContext.Provider value={contextValue}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext; 